/** Restore this single switch when the bouquet creator is ready for customers. */
export const BOUQUET_CREATOR_ENABLED = false;

export const KREATOR_SLUGS: string[] = [
  'roze', 'tulipany', 'sloneczniki', 'gerbery', 'lilie', 'eustomy',
];

/** Existing creator pages and the catalog/product aliases that expose the same offer. */
export const BOUQUET_CREATOR_PATHS: string[] = [
  '/kreatory/', '/kreatory-bukietow/',
  ...KREATOR_SLUGS.map(slug => `/kreator/${slug}/`),
  '/kreator-roz/', '/produkty/kreator-roz/',
  '/kolekcje/kreatory/', '/kolekcje/kreator-roz/',
  '/collections/kreatory/', '/collections/kreator-roz/',
];
const creatorPaths = new Set(BOUQUET_CREATOR_PATHS);

/** Match explicit local routes only; similarly named products and external links are unaffected. */
export function isBouquetCreatorPath(pathOrUrl: string): boolean {
  try {
    if (pathOrUrl.startsWith('//') || pathOrUrl.includes('\\')) return false;
    const localPath = pathOrUrl.startsWith('/') ? pathOrUrl
      : pathOrUrl.match(/^https?:\/\/(?:bukietowa\.pl|www\.bukietowa\.pl|staging\.bukietowa\.pl)(\/[^\s]*)$/i)?.[1];
    if (!localPath) return false;
    // Wouter's installed matcher is case-insensitive; the gate must cover the same routes.
    const pathname = decodeURI(localPath.split(/[?#]/, 1)[0]).toLowerCase().replace(/\/+$/, '') + '/';
    return creatorPaths.has(pathname);
  } catch {
    return false;
  }
}

export function isUnavailableBouquetCreatorPath(pathOrUrl: string): boolean {
  return !BOUQUET_CREATOR_ENABLED && isBouquetCreatorPath(pathOrUrl);
}

/** Also applies to inventories from a live API which has not received this release yet. */
export function filterAvailableSiteUrlEntries<T extends { path: string }>(entries: readonly T[]): T[] {
  return entries.filter(entry => !isUnavailableBouquetCreatorPath(entry.path));
}
